import { RegisterAprendizProgramaForm } from "@/components/forms/aprendicesProgramas/AprendicesProgramasForms";
import { Button } from "@/shared/components/ui/button";
import DataTable from "@/components/ui/dataTable";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Skeleton } from "@/components/ui/Skeleton";
import { UploadExcelForm } from "@/components/ui/UploadExcelForm";
import { useAprendicesProgramas } from "@/hooks/aprendicesProgramas/useAprendicesProgramas";
import { columns } from "@/lib/columns/aprendicesProgramas.columns";
import { useState } from "react";

export default function AprendicesProgramas() {
  const [open, setOpen] = useState(false);
  const [openCrear, setOpenCrear] = useState(false);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const limit = 10;

  const createAprendizProgramaModal = (
    <Dialog open={openCrear} onOpenChange={setOpenCrear}>
      <DialogTrigger asChild>
        <Button variant="headerAction" size="sm">
          + Registrar Aprendiz
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl xl:max-w-4xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Registrar Aprendiz</DialogTitle>
        </DialogHeader>
        <DialogDescription>
          Llena el siguiente formulario para registrar un nuevo aprendiz en el
          programa.
        </DialogDescription>
        <div className="py-4">
          <RegisterAprendizProgramaForm setOpen={setOpenCrear} />
        </div>
      </DialogContent>
    </Dialog>
  );

  const cargaMasivaModal = (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="headerAction" size="sm">
          + Carga Masiva
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-xl xl:max-w-3xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Inscribir aprendices por Excel</DialogTitle>
        </DialogHeader>
        <div className="py-4">
          <UploadExcelForm setOpen={setOpen} />
        </div>
      </DialogContent>
    </Dialog>
  );

  const headerActions = (
    <div className="flex flex-col sm:flex-row gap-2">
      {createAprendizProgramaModal}
      {cargaMasivaModal}
    </div>
  );

  const { data, isLoading, isFetching } = useAprendicesProgramas(
    page,
    limit,
    search,
  );

  if (isLoading) {
    return (
      <div className="space-y-2">
        <Skeleton className="h-10 w-64" />
        <Skeleton className="h-6 w-80" />
        <Skeleton className="h-40 w-full" />
      </div>
    );
  }

  return (
    <section className="w-full p-3 sm:p-4 md:p-6 space-y-4 sm:space-y-6">
      <DataTable
        columns={columns}
        data={data?.data ?? []}
        total={data?.total ?? 0}
        page={page}
        limit={limit}
        onPageChange={setPage}
        isLoading={isFetching}
        search={search}
        onSearchChange={(val) => {
          setPage(1);
          setSearch(val);
        }}
        headerActions={headerActions}
      />
    </section>
  );
}
